/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * If this is enabled, you can specify minimum and maximum values for Course Over Ground (COG). Only vessels with a COG inside the specified interval will generate events.
 * @export
 * @interface EventdetectorDefinitionCheckDirection
 */
export interface EventdetectorDefinitionCheckDirection {
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinitionCheckDirection
     */
    minAngle?: number;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinitionCheckDirection
     */
    maxAngle?: number;
}

/**
 * Check if a given object implements the EventdetectorDefinitionCheckDirection interface.
 */
export function instanceOfEventdetectorDefinitionCheckDirection(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorDefinitionCheckDirectionFromJSON(json: any): EventdetectorDefinitionCheckDirection {
    return EventdetectorDefinitionCheckDirectionFromJSONTyped(json, false);
}

export function EventdetectorDefinitionCheckDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorDefinitionCheckDirection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'minAngle': !exists(json, 'min_angle') ? undefined : json['min_angle'],
        'maxAngle': !exists(json, 'max_angle') ? undefined : json['max_angle'],
    };
}

export function EventdetectorDefinitionCheckDirectionToJSON(value?: EventdetectorDefinitionCheckDirection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'min_angle': value.minAngle,
        'max_angle': value.maxAngle,
    };
}

